import { useState } from 'react';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { InputValue, SearchInput, Stack } from '@optimus-web/core';
import { LocalizedSectionTitle } from '@mews-commander/ui';
import { sanitazeSearchValue } from '../utils';
import { MINIMAL_SEARCH_TOKEN_LENGTH } from '../constants';
import { SearchArticleList } from './SearchArticleList';
import { TrendingArticleList } from './TrendingArticleList';

export const KnowledgeBase = () => {
    const [searchToken, setSearchToken] = useState('');
    const handleSetSearchTerm = (value: string) => setSearchToken(sanitazeSearchValue(value));

    const [searchValue, setSearchValue] = useState('');

    const handleClear = () => {
        setSearchValue('');
        setSearchToken('');
    };

    const handleSetSearchValue = (event: React.ChangeEvent<HTMLInputElement> | React.MouseEvent, value: InputValue) => {
        const val = value.toString();
        if (val.length === 0) {
            setSearchToken('');
        }
        setSearchValue(val);
    };

    return (
        <Stack spacing="200" vertical>
            <LocalizedSectionTitle textKey={TextKey.FindGuide} />
            <SearchInput
                name="knowledgeBaseSearchTerm"
                placeholder={<LocalizedText textKey={TextKey.Search} />}
                onSearch={handleSetSearchTerm}
                onChange={handleSetSearchValue}
                onClear={handleClear}
                value={searchValue}
                clearable
            />
            {searchToken.length < MINIMAL_SEARCH_TOKEN_LENGTH ? (
                <TrendingArticleList />
            ) : (
                <SearchArticleList searchToken={searchToken} />
            )}
        </Stack>
    );
};
